module.exports = __webpack_public_path__ + "img/sideflag.0cde590.png";